import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AuthCallback() {
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const sessionId = new URLSearchParams(window.location.hash.replace("#", "")).get("session_id");
    axios
      .post(`${API}/auth/session`, { session_id: sessionId }, { withCredentials: true })
      .then((res) => {
        window.history.replaceState(null, "", window.location.pathname);
        navigate("/admin", { state: { user: res.data.user }, replace: true });
      })
      .catch(() => navigate("/login", { replace: true }));
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-paper" data-testid="auth-callback-loading">
      <p className="font-mono text-xs tracking-[0.3em] text-muted">SIGNING YOU IN...</p>
    </div>
  );
}
